import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'

export const ModalWrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;

    @media ${respondAbove.md} {
        min-height: auto;
        min-width: 328px;
    }
`
export const ModalHeader = styled(Box)`
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.grayscale_200};

    @media ${respondAbove.xl} {
        ${Text} {
            max-width: 100%;
        }
    }
`

export const ModalContent = styled(Box)`
    background-color: ${({ theme }) => theme.colors.darkmode_900};
    padding: 0 16px 24px;
    border-radius: 0 0 8px 8px;

    @media ${respondAbove.md} {
        padding: 0 40px 30px;
    }
`

interface ModalRowProps {
    isFirst?: boolean
    isLast?: boolean
}

export const ModalRow = styled(Box)<ModalRowProps>`
    padding-top: ${(props) => (props.isFirst ? '0px' : '16px')};
    padding-bottom: ${(props) => (props.isLast ? '0px' : '16px')};
    border-top: ${(props) =>
        props.isFirst
            ? '0px'
            : `1px solid ${props.theme.colors.grayscale_700}`};
`
